import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import SmsIcon from '@material-ui/icons/Sms';
import { green, yellow } from '@material-ui/core/colors';
import { useEffect, useState } from 'react';

const TotalComments = (props) => {
  const [total, setTotal] = useState(0);
  const { details } = props;
  useEffect(() => {
    if (details && details.length >= 0) {
      let r = 0;
      details.forEach(element => {
        r += element.note?.length > 0 ? 1 : 0;
      });
      setTotal(r);
    }
  }, [details]);

  return (
    <Card
      sx={{ height: '100%', boxShadow: 12 }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL COMMENTS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {total} Times
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: yellow[900],
                height: 56,
                width: 56
              }}
            >
              <SmsIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
};

export default TotalComments;
